export default __webpack_public_path__ + "static/media/btn-loader.627e92a9.svg";